module.exports = __webpack_public_path__ + "static/media/Escudo_Sucua.e9c70106.png";